// extracted by mini-css-extract-plugin
export default {"title":"a6955d1fac","bld":"_2f43f8ab5d"};